import React from 'react';
import { convertFromRaw, Editor, EditorState } from 'draft-js';
import 'draft-js/dist/Draft.css';
import PropTypes from 'prop-types';

const RichEditorReadOnly = ({ content }) => {
  if (!content) {
    return null;
  }

  const editorState = EditorState.createWithContent(convertFromRaw(content));
  
  // No-op function for read-only editor
  const handleChange = () => {};

  return (
    <div data-test="details-editor-form" className="RichEditor-root">
      <Editor 
        editorState={editorState} 
        onChange={handleChange}
        readOnly={true}
      />
    </div>
  );
};

RichEditorReadOnly.propTypes = {
  content: PropTypes.object
};

export default RichEditorReadOnly;
